import React from "react";
import styled from "styled-components";
import { useSearchParams } from "react-router-dom";

const Wrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 25px;
  background: #2a2a2a;

  color: #000;

  a {
    color: #000;

    &:hover {
      text-decoration: none;
    }
  }
`;

const Inner = styled.div`
  border: solid 1px #989898;
  padding: 40px 80px;
  background: #eaeaea;
`;

interface Props {}

const PrivacyPolicyView = ({}: Props) => {
  const [searchParams] = useSearchParams();
  let app_name = searchParams.get("app_name");

  if (app_name === null) {
    app_name = "UA State";
  }

  return (
    <Wrapper>
      <Inner>
        <h2>Політика конфіденційності</h2>
        <p>
          {`Додаток ${app_name} як безкоштовний додаток. Ця ПОСЛУГА надається
          безкоштовно та призначена для використання як є. Ця сторінка
          використовується для інформування відвідувачів щодо моєї політики щодо
          збору, використання та розкриття особистої інформації, якщо хтось
          вирішив скористатися моїм Сервісом. Якщо ви вирішите використовувати
          мій Сервіс, ви погоджуєтеся на збір і використання інформації стосовно
          цієї політики. Особиста інформація, яку я збираю, використовується для
          надання та покращення Сервісу. Я не використовуватиму та не
          повідомлятиму вашу інформацію нікому, крім випадків, описаних у цій
          Політиці конфіденційності. Терміни, які використовуються в цій
          Політиці конфіденційності, мають таке ж значення, що й у наших
          Положеннях та умовах, які доступні в ${app_name}, якщо інше не визначено
          в цій Політиці конфіденційності.`}
        </p>
        <h2>Збір і використання інформації</h2>
        <p>
          Для кращого досвіду використання нашого Сервісу я можу вимагати від
          вас надати нам певну особисту інформацію. Інформація, яку я запитую,
          зберігатиметься на вашому пристрої, і я жодним чином не збираю її.
        </p>
        <h2>Дані журналу</h2>
        <p>
          Я хочу повідомити вам, що щоразу, коли ви користуєтеся моїм Сервісом,
          у разі помилки в програмі я збираю дані та інформацію (через сторонні
          продукти) на вашому телефоні під назвою «Дані журналу». Ці дані
          журналу можуть містити таку інформацію, як адреса Інтернет-протоколу
          («IP») вашого пристрою, назва пристрою, версія операційної системи,
          конфігурація програми під час використання мого Сервісу, час і дата
          використання вами Сервісу та інші статистичні дані .
        </p>
        <h2>Cookies</h2>
        <p>
          Файли cookie – це файли з невеликою кількістю даних, які зазвичай
          використовуються як анонімні унікальні ідентифікатори. Вони
          надсилаються у ваш браузер із веб-сайтів, які ви відвідуєте, і
          зберігаються у внутрішній пам’яті вашого пристрою. Ця служба не
          використовує ці «куки» явно. Однак програма може використовувати код і
          бібліотеки сторонніх розробників, які використовують «куки» для збору
          інформації та покращення своїх послуг. У вас є можливість прийняти або
          відмовитися від цих файлів cookie та знати, коли файли cookie
          надсилаються на ваш пристрій. Якщо ви вирішите відмовитися від наших
          файлів cookie, можливо, ви не зможете використовувати деякі частини
          цієї служби.
        </p>
        <h2>Постачальники послуг</h2>
        <p>
          Я можу наймати сторонні компанії та фізичних осіб з наступних причин:
        </p>
        <ul>
          <li>Щоб полегшити наш сервіс;</li>
          <li>Для надання Сервісу від нашого імені;</li>
          <li>Надавати послуги, пов’язані з послугами; або</li>
          <li>
            Щоб допомогти нам проаналізувати, як використовується наш Сервіс.
          </li>
        </ul>
        <p>
          Я хочу повідомити користувачів цієї послуги, що ці треті сторони мають
          доступ до їх особистої інформації. Причина — виконання покладених на
          них завдань від нашого імені. Однак вони зобов’язані не розголошувати
          та не використовувати інформацію для будь-яких інших цілей.
        </p>
        <h2>Безпека</h2>
        <p>
          Я ціную вашу довіру щодо надання нам вашої Особистої інформації, тому
          ми намагаємося використовувати комерційно прийнятні засоби її захисту.
          Але пам’ятайте, що жоден метод передачі через Інтернет або метод
          електронного зберігання не є на 100% безпечним і надійним, і я не можу
          гарантувати його абсолютну безпеку.
        </p>
        <h2>Посилання на інші сайти</h2>
        <p>
          Ця служба може містити посилання на інші сайти. Якщо ви клацнете
          посилання третьої сторони, вас буде спрямовано на цей сайт. Зверніть
          увагу, що я не керую цими зовнішніми сайтами. Тому я настійно раджу
          вам переглянути Політику конфіденційності цих веб-сайтів. Я не
          контролюю та не несу відповідальності за вміст, політику
          конфіденційності чи практику будь-яких сторонніх сайтів чи служб.
        </p>
        <h2>Конфіденційність дітей</h2>
        <p>
          Я свідомо не збираю особисту інформацію дітей. Я закликаю всіх дітей
          ніколи не надавати будь-яку особисту інформацію через Програму та/або
          Сервіси. Я закликаю батьків і законних опікунів контролювати
          використання Інтернету своїми дітьми та сприяти дотриманню цієї
          Політики, інструктуючи своїх дітей ніколи не надавати ідентифікаційну
          інформацію через Програму та/або Послуги без їхнього дозволу. Якщо у
          вас є підстави вважати, що дитина надала нам особисту інформацію через
          Програму та/або Послуги, зв’яжіться з нами. Вам також має бути
          принаймні 16 років, щоб дати згоду на обробку вашої особистої
          інформації у вашій країні (у деяких країнах ми можемо дозволити вашим
          батькам або опікунам робити це від вашого імені).
        </p>
        <h2>Зміни в цій Політиці конфіденційності</h2>
        <p>
          Я можу час від часу оновлювати нашу Політику конфіденційності. Тому
          радимо періодично переглядати цю сторінку на предмет будь-яких змін. Я
          повідомлятиму вас про будь-які зміни, опублікувавши нову Політику
          конфіденційності на цій сторінці. Ця політика діє з 05.05.2023
        </p>
        <h2>Зв'яжіться з нами</h2>
        <p>
          Якщо у вас є запитання чи пропозиції щодо моєї Політики
          конфіденційності, не соромтеся зв’язатися зі мною за адресою:
          nbwapps@gmail.com.
        </p>
      </Inner>
    </Wrapper>
  );
};

export default PrivacyPolicyView;
